<nb-card>
  <nb-card-header>
    <div class="d-flex justify-content-between">
      <h3 class="h3">{{"Farms" | tenantWords}}</h3>
      <div class="d-flex align-items-center">
        <button mat-raised-button class="me-2" (click)="downloadTemplate()">
            Download Template <fa-icon [icon]="faFileDownload"></fa-icon>
          </button>
          <button mat-raised-button class="uploadButton me-2" (click)="fileInput.click()">
            Upload Excel File <fa-icon [icon]="faFileUpload"></fa-icon>
          </button>
          <input #fileInput type="file" (change)="onFileSelected($event)" accept=".xlsx,.xls" style="display: none;">
        <div class="me-3 filter-badge-wrapper">
          <button mat-stroked-button class="btn text-dark btn-sm" (click)="clearFilters()">
            <fa-icon [icon]="faBan" class="me-2"></fa-icon>Clear Filters
          </button>
          <span *ngIf="farmsTable && farmsTable.filterCount > 0" class="filter-badge">{{farmsTable.filterCount}}</span>
        </div>
        <button mat-raised-button color="primary" (click)="newFarmClicked()">
          <fa-icon class="me-2" [icon]="faPlus" size="sm"></fa-icon>New {{"Farm" | tenantWords}}
        </button>
      </div>
    </div>
  </nb-card-header>
    <nb-card-body class="p-0">
        <kw-farms-table #farmsTable (loaded)="onLoaded()"></kw-farms-table>
    </nb-card-body>
</nb-card>